ShopTheme.passwordChecker = (function () {
	var form,
		password,
		confirmPassword,
		passwordError,
		passwordErrorMessage,
		showPasswordCheckbox;

	function doesPasswordMeetCriteria(passwordValue) {
		var regex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
		return regex.test(passwordValue);
	}

	function togglePasswordVisibility(isVisible) {
		var type = isVisible ? "text" : "password";
		password.type = type;
		confirmPassword.type = type;
	}

	function validatePasswords() {
		var passwordsMismatch = password.value !== confirmPassword.value;
		var arePasswordsEmpty =
			password.value === "" || confirmPassword.value === "";
		var isPasswordValid = doesPasswordMeetCriteria(password.value);

		if (arePasswordsEmpty) {
			return { valid: false, message: "data-passwords-empty" };
		} else if (passwordsMismatch) {
			return { valid: false, message: "data-emails-do-not-match" };
		} else if (!isPasswordValid) {
			return { valid: false, message: "data-regex-error" };
		}

		return { valid: true };
	}

	function setUpEventListeners() {
		if (showPasswordCheckbox) {
			showPasswordCheckbox.addEventListener("change", function () {
				togglePasswordVisibility(this.checked);
			});
		}

		if (form) {
			form.addEventListener("submit", function (event) {
				var validationResult = validatePasswords();

				ShopTheme.Global.toggleVisibility(
					passwordError,
					!validationResult.valid
				);
				if (!validationResult.valid) {
					passwordErrorMessage.textContent = passwordErrorMessage.getAttribute(
						validationResult.message
					);
					event.preventDefault();
				} else {
					passwordErrorMessage.textContent = "";
				}
			});
		}
	}

	function init() {
		form = document.querySelector(".password-form");
		password = document.getElementById("CustomerPassword");
		confirmPassword = document.getElementById("ConfirmPassword");
		passwordError = document.getElementById("PasswordError");
		passwordErrorMessage = document.getElementById("PasswordErrorMessage");
		showPasswordCheckbox = document.getElementById("show-password");

		setUpEventListeners();
	}

	return {
		init: init,
	};
})();

document.addEventListener("DOMContentLoaded", ShopTheme.passwordChecker.init);
